import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Alert, Modal, ModalBody, ModalHeader, Row, Spinner } from 'reactstrap';
import { Button, Col, Icon } from '../Component';
import TextInput from '../../pages/components/inputs/TextInput';
import { tenant_auth_actions_helper } from '../../actions/actions_helper';
import { TENANT_CANCEL_ORDER_ITEM_API } from '../../api/api_data';
import { fail_tenant_cancel_order_item, loading_tenant_cancel_order_item, reset_tenant_cancel_order_item, success_tenant_cancel_order_item } from '../../reducers/auth_tenant/tenant_cancel_order_item_Slice';
import { CANCEL_ORDER_ITEM_ERROR_MSG, CANCEL_ORDER_ITEM_SUCCESS_MSG } from '../../utils/error_success_messages';
import { useSelector } from 'react-redux';
import { messageToast } from '../../utils/Utils';
import * as app_consts from "../../utils/app_consts";


const initialState = { order_item_id: "", reason: "" };

const TenantCancelOrderItem = ({ tenant_info, user_info, isOpen, successFunction, closeModal, data }) => {

 const [open, setOpen] = useState(isOpen);
 const [loading, setLoading] = useState(false);
 const dispatch = useDispatch();
 const [error, setError] = useState("");
 const [formData, setFormData] = useState(initialState);
 const [page_data, setPagData] = useState(data);


 useEffect(() => {
  setOpen(isOpen);
  setFormData(initialState);
  setPagData(data);
 }, [isOpen]);

 const handleChange = (e) => {
  setFormData({ ...formData, reason: e.target.value });
 };

 const confirmClick = () => {
  setError("");
  // Dispatch
  dispatch(tenant_auth_actions_helper(loading_tenant_cancel_order_item, success_tenant_cancel_order_item, fail_tenant_cancel_order_item, CANCEL_ORDER_ITEM_ERROR_MSG, CANCEL_ORDER_ITEM_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${TENANT_CANCEL_ORDER_ITEM_API}`, { ...formData, order_item_id: page_data?.id }));
 };
 // Listener
 const tenant_cancel_order_item_listener = useSelector((state) => state.tenant_cancel_order_item.tenant_cancel_order_item);

 useEffect(() => {
  if (tenant_cancel_order_item_listener.status !== app_consts.IDLE)
  {
   if (tenant_cancel_order_item_listener.status === app_consts.LOADING)
   {
    setLoading(true);
    setError("");
   } else
   {
    if (tenant_cancel_order_item_listener.status === app_consts.FAIL)
    {
     setError(tenant_cancel_order_item_listener.message);
     messageToast(tenant_cancel_order_item_listener.message, app_consts.FAIL);
    } else if (tenant_cancel_order_item_listener.status === app_consts.SUCCESS)
    {
     successFunction();
     messageToast(CANCEL_ORDER_ITEM_SUCCESS_MSG, app_consts.SUCCESS);
     closeModal();
    }
    setLoading(false);
    dispatch(reset_tenant_cancel_order_item());
   }
  }
 }, [tenant_cancel_order_item_listener]);

 return (
  <>
   <Modal isOpen={open} className="modal-dialog-centered" size={"md"} >
    <ModalHeader toggle={loading ? "" : closeModal}>{`Cancel Order Item ${page_data && (`${page_data?.product?.name} (${page_data?.product?.category})`)} ?`}</ModalHeader>
    <ModalBody>
     <Row className="g-4">
      {error && (
       <div className="mb-3 w-100">
        <Alert color="danger" className="alert-icon">
         <Icon name="alert-circle" /> {error}{" "}
        </Alert>
       </div>
      )}
      <p>{`Are you Sure that you want to Cancel ${page_data && (`${page_data?.product?.name} (${page_data?.product?.category})`)} ?`}</p>
      <TextInput
       colSize={12}
       parentClassName="mt-2"
       label="Reason"
       type="text"
       id_val="input"
       handleChange={handleChange}
       name="input"
       required
      />
      <Col xl="12" className="d-flex justify-between mt-4 mr-2">
       <Button onClick={() => { setOpen(!isOpen); }} className="btn-secondary">No</Button>
       <Button onClick={confirmClick} disabled={loading || !(formData?.reason)} className=" btn-danger ">
        {loading ? <Spinner size="sm" /> : "Cancel Order Item"}
       </Button>
      </Col>
     </Row>
    </ModalBody>
   </Modal>
  </>
 );
};

export default TenantCancelOrderItem;